const url = 'https://unpkg.com/wasm-imagemagick/dist/bundles/magickApi.js';
import(url).then(Magick => {
    async function fetchImage(url: string) {
        const image = await fetch(url, {
            headers: {
                'Sec-Fetch-Dest': 'image'
            }
        });
        return new Uint8Array(await image.arrayBuffer())
    }

    async function getProcessedImage(url: string) {
        const image = document.createElement('img');

        const processed = await Magick.Call([
            await Magick.buildInputFile(url, 'in.png')
        ], [
            //Let's initialise the image
            'convert', 'in.png', '-bordercolor', 'white', '-border', '1x1',
            // Set Alpha to most of the image
            '-alpha', 'set', '-channel', 'RGBA', '-fuzz', '20%',
            // Fill the image with white
            '-fill', 'none', '-floodfill', '+0+0', 'white',
            // Clean and set transparent
            '-shave', '1x1', '-transparent', 'white',
            // Increase the saturation
            '-level', '30%',

            // Convert to grey
            '-modulate', '100,0',
            '-channel', 'RGBA', '-transparent', 'white',

            '-evaluate', 'Divide', '1.5',
            // Export
            'out.png',
        ]);

        const processed_grey = await Magick.Call([
            { name: 'in.png', content: processed[0]['buffer'] }
        ], [
            'convert', 'in.png',
            // Convert to grey
            '-modulate', '100,0',
            '-channel', 'RGB',
            '-threshold', '80%',
            '-channel', 'RGBA', '-transparent', 'white',
            'out.png'
        ]);

        const firstImage = processed[0];
        image.src = URL.createObjectURL(firstImage['blob']);

        return image;
    }


    async function init() {
        const img = document.querySelector('img[alt="machine.png"]').src
        const image = await getProcessedImage(img);
        document.getElementById('demo').appendChild(image);

    }

    init();
});
